import React from 'react';
import styled from '@emotion/styled';
import validation, { isRequired, isValidUrl } from '../utils/validation';
import InputField from './InputField';

const HeightContainer = styled('div')`
  min-height: 75px;
`;

const IframePrompt = ({ formData }) => {
  return (
    <HeightContainer>
      <InputField
        name="src"
        required={true}
        label="VIDEO EMBED CODE OR YOUTUBE/VIMEO LINK"
        autoFocus={true}
        validate={validation(isRequired, isValidUrl)}
        formData={formData}
      />
    </HeightContainer>
  );
};

export default IframePrompt;



// WEBPACK FOOTER //
// ./app/javascript/client/editor-ui/prompts/IframePrompt.jsx